var _linearGradient, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 512,
    x2: 512,
    y1: 1024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d76f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ac2fb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1024v1024H0z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333 745.5l.095.03-34.547 59.837c-12.61 21.842-40.541 29.326-62.383 16.715-21.841-12.609-29.325-40.54-16.715-62.382l25.45-44.08 2.442-4.23c4.362-6.271 15.126-17.089 36.657-15.056 0 0 50.667 5.499 54.333 31.833.001 0 .501 8.666-5.332 17.333zm489.998-152.833H715.267c-7.336-.491-10.541-3.111-11.798-4.634l-.08-.139L588.066 388.15l-.149.1-6.917-9.917c-11.334-17.333-29.333 27-29.333 27-21.49 49.399 3.049 105.564 11.606 122.539l160.176 277.433c12.609 21.842 40.54 29.326 62.382 16.715 21.841-12.609 29.325-40.54 16.715-62.382l-40.054-69.374c-.775-1.68-2.126-6.245 6.088-6.263h54.418c25.221 0 45.667-20.446 45.667-45.667s-20.446-45.667-45.667-45.667zM613.75 654.75S619.5 684 597.25 684H575v.001H198.999c-25.221 0-45.667-20.446-45.667-45.667s20.446-45.667 45.667-45.667h102.386c16.53-.958 20.449-10.5 20.449-10.5l.09.046 133.648-231.486-.04-.008c2.437-4.472.408-8.697.055-9.366l-44.137-76.447c-12.611-21.842-5.127-49.772 16.715-62.382 21.842-12.611 49.771-5.127 62.382 16.715l20.47 35.456 20.434-35.393c12.61-21.842 40.54-29.326 62.382-16.715s29.326 40.541 16.715 62.382L424.573 587.086c-.813 1.961-1.062 5.039 4.988 5.581h111.165l.024 1.083s64.25 1 73 61z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore1);
export default __webpack_public_path__ + "static/media/app-store-1.7c2cecd720e1f061ff2db0133c0c8992.svg";
export { ForwardRef as ReactComponent };